import { Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { t } from '@/i18n';
import type { CompanyListItem } from '@ip/shared-types';

interface BulkAssignDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  companies: CompanyListItem[];
  targetNip: string | null;
  onTargetChange: (nip: string | null) => void;
  count: number;
  updating: boolean;
  onSubmit: () => void;
}

export function BulkAssignDialog({
  open,
  onOpenChange,
  companies,
  targetNip,
  onTargetChange,
  count,
  updating,
  onSubmit,
}: BulkAssignDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('invoices.bulk.assignModalTitle')}</DialogTitle>
        </DialogHeader>
        <p className="text-muted-foreground text-sm">
          {t('invoices.bulk.assignModalDescription', { count })}
        </p>
        <Select value={targetNip ?? ''} onValueChange={(v) => onTargetChange(v || null)}>
          <SelectTrigger className="w-full">
            <SelectValue placeholder={t('invoices.bulk.selectCompany')} />
          </SelectTrigger>
          <SelectContent>
            {companies.map((c) => (
              <SelectItem key={c.nip} value={c.nip}>
                {c.name} ({c.nip})
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            {t('common.cancel')}
          </Button>
          <Button disabled={!targetNip || updating} onClick={onSubmit}>
            {updating && <Loader2 className="size-4 animate-spin" />}
            {t('invoices.bulk.assignToCompany')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
